import { Component, HostListener, OnInit } from '@angular/core';
import { Medication } from 'src/app/models/medication';
import { MedicationService } from '../../../services/medication.service';
import { Settings } from '../../../services/settings';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { TransactionHistoryComponent } from 'src/app/components/transaction-history/transaction-history';
import { MedicationFamily } from 'src/app/models/medicationfamily';
import { MedSearchStructure } from '../../../models/med-search-structure';
import { SearchMedicationsComponent } from '../../shared/search-medications/search-medications.component';
import { MedicationSuppliersComponent } from './property-tabs/medication-suppliers/medication-suppliers.component';
import { MedicationImagesComponent } from './property-tabs/medication-images/medication-images.component';
import { MedicationLinksComponent } from './property-tabs/medication-links/medication-links.component';
import { MedFamLookupComponent } from './medfamlookup/medfamlookup.component';
import { forkJoin } from "rxjs";
import { DataRecord, DataRecordInt } from '../../../models/datarecord';
import { error } from 'protractor';
import { ManufacturedBy, ManufacturedFor } from 'src/app/models/manufacturer';

@Component({
	selector: 'app-medications-inv',
	templateUrl: './medications-inv.component.html',
	styleUrls: ['./medications-inv.component.css']
})
export class MedicationsInvComponent implements OnInit {

	public isEditing = false;
	public isAdd = false;
	public propContainerState = false;
	public pagination: string;
	public visiblePropertiesTab = true;
	public selectedTabIndex = 0;
	public selectedViewFilter = 'List';
	public busyCursor: boolean | null = false;
	public result: boolean | null = false;
	public contentClassWithBanner = 'dwtable-container';
	public contentClassWithoutBanner = 'dwtable-container-without-header';
	public contentClassName = 'dwtable-container';
	public disabledFlag = true;
	public formTitle = 'Medications';
	public strErr = '';
	public BASE_URL = Settings.getInstance().BASE_URL;
	public medicationsListOriginal: Medication[];
	public medicationsList: Medication[];
	public medicationFamilyList: MedicationFamily[];
	public selectedRecord: Medication;
	public selectedMedicationFamily: MedicationFamily;
	public historyRecord: Medication;
	public renderedData = Array<Medication>();
	public displayedColumns: string[] = ['id', 'origNdcNumber', 'description', 'manufacturedBy', 'packageSize', 'awp', 'activeStatus'];
	public dataSource: MatTableDataSource<Medication>; // = new MatTableDataSource(ELEMENT_DATA);

	public visibleAdd = false;
	public visibleModify = false;
	public visibleDelete = false;
	public Idx = -1;
	public selectedStatusFilter: string | null = 'Active';

	public strFilterText: string = '';
	public valSchedule: any;
	public valOMNDCNumber: any;
	public valRawNDCNumber: any;
	public valItemPrefix: any;
	public valShortDesc: any;
	public valDesc: any;
	public valPkgSize: any;
	public valGenricOrBrand: any;
	public valUnit: any;
	public valLotNumber: any;
	public valCostBase: any;
	public valAWP: any;
	public valStatus: any;
	public valId: any;
	public valCompareTo: any;
	public valNdcFormat: any;
	public valMedicationFamily: any;
	public manufactureByList: ManufacturedBy[];
	public manufactureForList: ManufacturedFor[];

	public selectedManuFor: ManufacturedFor;
	public selectedManuBy: ManufacturedBy;
	public selectedNdcFormat: DataRecordInt;
	public ndcFormatList: any;
	public valStorageInstructions: any;
	public valIngredients: any;

	public dataList: any;
	public displaySearchDlg: boolean = true;
	public displayMedFamilyDlg = false;
	public hideNoRecs: boolean = true;
	public drawerTabIdx = 0;

	public medSearchStructHist: MedSearchStructure;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;
	@ViewChild('search', { static: true }) search: SearchMedicationsComponent;
	@ViewChild('suppliers', { static: true }) suppliers: MedicationSuppliersComponent;
	@ViewChild('images', { static: true }) images: MedicationImagesComponent;
	@ViewChild('links', { static: true }) links: MedicationLinksComponent;
	@ViewChild('medFamilyLookup', { static: true }) medFamilyLookup: MedFamLookupComponent;

	constructor(private medicationService: MedicationService,
		private dialog: MatDialog, private txService: TransactionHistoryService) {
		/** ndc format listing **/
		this.ndcFormatList = [];
		this.ndcFormatList.push(new DataRecordInt(541, 'Five-four-one'));
		this.ndcFormatList.push(new DataRecordInt(532, 'Five-three-two'));
		this.ndcFormatList.push(new DataRecordInt(442, 'Four-four-two'));
		this.medicationsList = [];
		this.dataSource = new MatTableDataSource<Medication>();

		this.queryMedicationFamilyRecords();
	}

	ngOnInit() {
		// Now let's set the access privilege level
		if (Settings.getInstance().hasPrivilege('MANAGE_MEDICATIONS', false)) {
			this.visibleAdd = true;
		}
		if (Settings.getInstance().hasPrivilege('MANAGE_MEDICATIONS', false)) {
			this.visibleModify = true;
		}
		if (Settings.getInstance().hasPrivilege('MANAGE_MEDICATIONS', false)) {
			this.visibleDelete = true;
		}

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
		this.dataSource = new MatTableDataSource();
		this.getManufacturerTables();
	}
	public getManufacturerTables(): void {

		const manuFor = this.medicationService.getAllManufactureFor();
		const manuBy = this.medicationService.getAllManufactureBy();

		forkJoin([manuFor, manuBy]).subscribe(results => {
			this.manufactureForList = results[0];
			this.manufactureByList = results[1];
		});

	}
	public openSearchDialog(): void {
		this.displaySearchDlg = true;
		this.search.showDialogFocus();
	}
	public globalSearchSelect(medSearchStruct: MedSearchStructure): void {

		this.queryRecords(medSearchStruct);
		this.displaySearchDlg = false;
	}
	public queryMedicationFamilyRecords() {

		this.busyCursor = true;
		this.medicationFamilyList = new Array<MedicationFamily>();
		this.medicationService.getAllMedicationFamily().subscribe(
			(result) => {
				this.medicationFamilyList = result;
				this.busyCursor = false;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve data from the service');
				this.busyCursor = false;
			}
		);
	}
	public queryRecords(sm: MedSearchStructure) {


		if (sm === undefined) {
			this.strErr = 'Error: Please click the \"Search\" button to specify a medication to find';
			return;
		}
		else {
			this.strErr = '';
		}

		this.medSearchStructHist = sm;
		this.busyCursor = true;
		this.medicationService.getMedicationsFromSearch(sm).subscribe(
			(result) => {
				this.medicationsListOriginal = result;
				this.medicationsList = result;
				// this.applyStatusFilter();
				this.onChangeStatusFilterValue();
				this.setPagination(-1, this.medicationsList.length);
				if (this.isAdd === true) {
					this.selectedRecord = this.dataSource.data[this.dataSource.data.length - 1];
					this.displayDetail(this.selectedRecord);
				}
				this.dataSource = new MatTableDataSource(this.medicationsList);
				this.busyCursor = false;
				this.hideNoRecs = (this.medicationsList.length > 0);
				this.unSelectRow();
			});
	}
	public refreshButtonClickHandler() {
		this.queryRecords(this.medSearchStructHist);
	}
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public applyFilter(filterValue: string) {
		if (this.isEditing) return;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		this.unSelectRow();
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	@HostListener('matSortChange', ['$event'])
	onSortChange(event: any) {

		let isInt = false;

		if ((event.active === 'id') || (event.active === 'packageSize') || (event.active === 'awp')) {
			isInt = true;
		}

		if (event.direction === 'asc') {
			if (isInt) {
				this.medicationsList.sort((a, b) =>
					a[event.active] - (b[event.active]));
			} else {
				this.medicationsList.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (isInt) {
				this.medicationsList.sort((a, b) =>
					b[event.active] - (a[event.active]));
			} else {
				this.medicationsList.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.medicationsList;
		//this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public onStatusChange() {

		this.medicationService.updateMedication(this.selectedRecord).subscribe(
			(data) => {
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue();
			});
	}
	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date, number)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else if (!isNaN(value)) {
			return parseFloat(value);
		} else {
			return value ?? '';
		}
	}
	public selectRow() {
		//if (this.selectedRecord.schedule === undefined || this.selectedRecord.schedule.length === 0) {
		//	return;
		//}
		if (this.selectedRecord == undefined || this.selectedRecord.id === 0) {
			this.unSelectRow();
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		//console.log('ID: ' + this.selectedRecord.id + ' - AT: ' + this.Idx);
	}
	public unSelectRow() {
		/* if (this.isEditing) return; */
		this.Idx = -1;
		this.selectedRecord = new Medication();
		this.setPagination(this.Idx, this.medicationsList.length);
		this.displayDetail(this.selectedRecord);

	}
	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = '';

		this.unSelectRow();
		this.setPagination(-1, this.medicationsList.length);

	}
	public displayDetail(record: Medication) {

		switch (this.selectedTabIndex) {
			case 0:
				this.displayDetailRecord(record);
				break;
			case 1:
				this.history.onShowHandler('Medications', 'id', record.id.toString());
				break;
			default:
				break;
		}
		this.displayDrawerData();
	}
	public displayDetailRecord(record: Medication): void {
		if (record === undefined || record.id === 0 || record.schedule === undefined) {
			return;
		}
		this.valNdcFormat = this.selectedRecord.ndcFormat;
		this.setNDCFormat(this.selectedRecord.ndcFormat);
		this.valPkgSize = record.packageSize;
		this.valDesc = record.description;
		this.valId = record.id;
		this.valOMNDCNumber = this.selectedRecord.origNdcNumber;
		this.valRawNDCNumber = this.selectedRecord.rawNdcNumber;
		this.valPkgSize = this.selectedRecord.packageSize;
		this.valStatus = this.selectedRecord.activeStatus;
		this.valAWP = this.selectedRecord.awp;
		if(this.selectedRecord.medicationFamilyId){
			this.valMedicationFamily = this.getMedicationFamily(this.selectedRecord.medicationFamilyId).description;			
		}
		this.setSelectedManufacturer(this.selectedRecord.manufacturedById, 'by');
		this.setSelectedManufacturer(this.selectedRecord.manufacturedForId, 'for');

		this.valStorageInstructions = this.selectedRecord.storageInstructions;
		this.valIngredients = this.selectedRecord.ingredients;
	}
	public setSelectedManufacturer(id: number, arr: string): void {
		if(!id){return;}
		if (arr === 'for') {
			this.selectedManuFor = this.manufactureForList.find(s => s.id === id);
		}
		else {
			this.selectedManuBy = this.manufactureByList.find(s => s.id === id);
		}

	}
	public getManufactByName(id: number): string {
		const manuBy = this.manufactureByList.find(s => s.id === id);
		if (manuBy) {
			return manuBy.description;
		} else {
			"";
		}

	}
	public setNDCFormat(ndcFmt: number): void {
		this.selectedNdcFormat = this.ndcFormatList.find(s => s.id === ndcFmt);
	}
	public formatNdc(event: any): void {

		this.setNDCFormat(event);

		if (this.valOMNDCNumber.length === undefined || this.valOMNDCNumber === null) {
			return;
		}
		const saveNDC = this.valOMNDCNumber;
		const rawNdc = this.valOMNDCNumber.replaceAll('-', '');
		let counter = 0;
		let tmpReverse = '';

		for (let i = rawNdc.length - 1; i > - 1; i--) {
			tmpReverse += rawNdc[i];
			counter++;

			switch (Number(this.selectedNdcFormat.id)) {
				case 532:
					if (counter === 2 || counter === 5) {
						tmpReverse += '-';
					}
					break;
				case 541:
					if (counter === 1 || counter === 5) {
						tmpReverse += '-';
					}
					break;
				case 442:
					if (counter === 2 || counter === 6) {
						tmpReverse += '-';
					}
					break;
				default:
					tmpReverse = saveNDC;
					break;
			}
		}
		/** reverse the string so that it is the right way round **/
		this.valNdcFormat = this.selectedNdcFormat.id;
		this.valOMNDCNumber = tmpReverse.split('').reverse().join('');
	}
	public deriveOrigFromRaw(): void {
		if (!this.valRawNDCNumber || this.valRawNDCNumber.length < 12) {
			this.strErr = 'Raw NDC must be at least 12 digits';
			return;
		}
		if (!this.selectedNdcFormat) {
			this.strErr = 'Please select an NDC format';
			return;
		}

		// Extract 10-digit NDC based on raw NDC length (orig NDC is always 10 digits)
		let rawNdc = '';
		if (this.valRawNDCNumber.length === 12) {
			// 12-digit: Remove first and last digit to get 10 digits
			rawNdc = this.valRawNDCNumber.substring(1, 11);
		} else if (this.valRawNDCNumber.length === 14) {
			// 14-digit GTIN: Skip first 2 digits, take next 10 digits
			rawNdc = this.valRawNDCNumber.substring(2, 12);
		} else if (this.valRawNDCNumber.length === 13) {
			// 13-digit: Skip first 2 digits, take next 10 digits
			rawNdc = this.valRawNDCNumber.substring(2, 12);
		} else {
			// For other lengths, take middle 10 digits
			const startPos = Math.max(0, Math.floor((this.valRawNDCNumber.length - 10) / 2));
			rawNdc = this.valRawNDCNumber.substring(startPos, startPos + 10);
		}
		
		// Format based on NDC format: insert dashes at correct positions
		let formattedNdc = '';
		switch (Number(this.selectedNdcFormat.id)) {
			case 532: // 5-3-2 format
				formattedNdc = rawNdc.substring(0, 5) + '-' + 
				               rawNdc.substring(5, 8) + '-' + 
				               rawNdc.substring(8, 10);
				break;
			case 541: // 5-4-1 format
				formattedNdc = rawNdc.substring(0, 5) + '-' + 
				               rawNdc.substring(5, 9) + '-' + 
				               rawNdc.substring(9, 10);
				break;
			case 442: // 4-4-2 format
				formattedNdc = rawNdc.substring(0, 4) + '-' + 
				               rawNdc.substring(4, 8) + '-' + 
				               rawNdc.substring(8, 10);
				break;
		}

		this.valOMNDCNumber = formattedNdc;
		this.strErr = '';
	}
	public clear() {
		this.valMedicationFamily = '';
		this.valShortDesc = '';
		this.valPkgSize = '';
		this.valDesc = '';
		this.valId = '';
		this.valOMNDCNumber = '';
		this.valRawNDCNumber = '';
		this.valItemPrefix = '';
		this.valPkgSize = '';
		this.valStatus = '';
		this.valGenricOrBrand = '';
		this.valSchedule = '';
		this.valCostBase = '';
		this.valAWP = '';
		this.valCostBase = '';
		this.valUnit = '';
		this.valLotNumber = '';
		this.valCompareTo = '';
		this.selectedManuBy = null;
		this.selectedManuFor = null;
		this.valIngredients = '';
		this.valStorageInstructions = '';
	}
	public onChangeStatusFilterValue() {

		const dataTemp = [];
		this.clearFilter();

		for (const rec of this.medicationsListOriginal) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;

		if (this.propContainerState) {
			this.displayDrawerData();
		}
	}
	public tableKeyDown(event: KeyboardEvent) {

		if (this.isEditing) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.selectedMedicationFamily = this.getMedicationFamily(this.selectedRecord.medicationFamilyId);
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.selectedMedicationFamily = this.getMedicationFamily(this.selectedRecord.medicationFamilyId);
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.medicationsList.length);
	}
	public doTabChange(event): void {
		this.displayDetail(this.selectedRecord);
	}
	public doDrawerSelectedTabChange(event: any): void {
		this.drawerTabIdx = event.index;
		this.displayDrawerData();

	}
	public displayDrawerData(): void {
		if (!this.selectedRecord) {
			return;
		}
		if (!this.propContainerState) {
			return;
		}
		switch (this.drawerTabIdx) {
			case 0:
				this.suppliers.queryRecords(this.selectedRecord.id);
				break;
			case 1:
				this.images.queryRecords(this.selectedRecord.id);
				break;
			case 2:
				this.links.queryRecords(this.selectedRecord.id);
				break;
		}
	}
	public addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;
		if (this.selectedTabIndex === 2) {
			this.selectedTabIndex = 0;
		}
		if (this.isAdd) {
			this.unSelectRow();
			this.clear();
			this.selectedNdcFormat = this.ndcFormatList[1];
			this.valNdcFormat = this.selectedNdcFormat.id;
			this.valStatus = 'Active';
			this.valSchedule = 0;
			DwUtils.setFocus('rawNdcNumber');

		} else {
			this.historyRecord = new Medication();
			for (const prop in this.selectedRecord) {
				this.historyRecord[prop] = this.selectedRecord[prop];
			}
		}

	}
	public doNDCFocusOut(): void {

		if (this.valOMNDCNumber.length > 0) {
			/* get the manufor values using the first segment of the ndc (called the labeler code). */
			const fSegment = this.valOMNDCNumber.split('-')[0];
			const sRec = this.manufactureForList.find(s => s.labeler === fSegment);
			if (sRec !== undefined) {
				//this.selectedManuFor = new DataRecord(sRec.id, sRec.Description);
				this.selectedManuFor = this.manufactureForList.find(item => item.id === sRec.id);
			}
			this.chkDuplicateNDCNumber(this.valOMNDCNumber);
		}
	}
	public chkInputDigits(event: KeyboardEvent) {

		if (isNaN(Number(event.key))) {
			if ((event.key === 'Enter') || (event.key === 'Tab')) {
				return;
			}
			if ((event.key === 'Backspace') || (event.key === 'Delete')) {
				return;
			}

			if (event.key === '-') {
				return;
			}
			event.preventDefault();
		}
	}
	public validateFields() {

		if (this.valMedicationFamily === undefined || this.valMedicationFamily === null || this.valMedicationFamily === 0) {
			this.strErr = 'Please set the Medication Family';
			DwUtils.setFocus('medicationFamily');
			return false;
		}

		if (this.valRawNDCNumber === undefined || this.valRawNDCNumber === null || this.valRawNDCNumber.length === 0) {
			this.strErr = 'Please enter Raw NDC Number';
			DwUtils.setFocus('rawNdcNumber');
			return false;
		}

		if (this.valRawNDCNumber.length < 12 || !/^\d+$/.test(this.valRawNDCNumber)) {
			this.strErr = 'Raw NDC must be at least 12 digits';
			DwUtils.setFocus('rawNdcNumber');
			return false;
		}

		if (this.valOMNDCNumber === undefined || this.valOMNDCNumber.length === 0) {
			this.strErr = 'Please enter Original NDC Number';
			DwUtils.setFocus('ndcNumber');
			return false;
		}
		/*if (this.isDuplicateNDCNumber(this.valOMNDCNumber)) {
			this.strErr = 'A Duplicate NDC Number Was Entered';
			DwUtils.setFocus('ndcNumber');
			return false;
		} */
		/* if (this.valSchedule === undefined || this.valSchedule.length === 0) {
			this.strErr = 'Please enter Schedule';
			DwUtils.setFocus('schedule');
			return false;
		} */
		if (this.valStatus === undefined || this.valStatus.length === 0) {
			this.strErr = 'Please select Status';
			DwUtils.setFocus('status');
			return false;
		}
		if (this.valPkgSize === undefined || this.valPkgSize.length === 0) {
			this.strErr = 'Please enter Package size';
			DwUtils.setFocus('vackagesize');
			return false;
		}
		return true;
	}
	public submitRecord() {
		this.strErr = '';
		if (!this.validateFields()) {
			return;
		}

		if (this.isAdd) {
			let newRecord = new Medication();
			newRecord = new Medication();
			newRecord.description = String(this.valDesc).toUpperCase();
			newRecord.origNdcNumber = this.valOMNDCNumber;
			newRecord.rawNdcNumber = this.valRawNDCNumber;
			newRecord.ndcFormat = this.valNdcFormat;
			newRecord.packageSize = this.valPkgSize;
			newRecord.activeStatus = this.valStatus;
			newRecord.awp = this.valAWP;
			if (this.selectedMedicationFamily) {
				newRecord.medicationFamilyId = this.selectedMedicationFamily.id;
			}
			if (this.selectedManuBy) {
				newRecord.manufacturedById = this.selectedManuBy.id;
			}
			if (this.selectedManuFor) {
				newRecord.manufacturedForId = this.selectedManuFor.id;
			}


			newRecord.storageInstructions = String(this.valStorageInstructions).toUpperCase();
			newRecord.ingredients = this.valIngredients;

			this.medicationService.createMedication(newRecord).subscribe(
				(data2) => {
					/*** add a transaction history record ***/
					newRecord.id = data2.id;
					this.selectedRecord = newRecord;
					this.txService.createTransactionHistory('Medications', data2.id);
					this.updateSelectedRow();
					this.strErr = '';
					this.isEditing = false;
				},
				(error) => {
				}
			);

		} else {
			/* delete this.selectedRecord['medicationFamily']; */
			this.selectedRecord.description = String(this.valDesc).toUpperCase();
			this.selectedRecord.origNdcNumber = this.valOMNDCNumber;
			this.selectedRecord.rawNdcNumber = this.valRawNDCNumber;
			this.selectedRecord.ndcFormat = this.valNdcFormat;
			this.selectedRecord.packageSize = this.valPkgSize;
			this.selectedRecord.activeStatus = this.valStatus;
			this.selectedRecord.awp = this.valAWP;
			if (this.selectedMedicationFamily) {
				this.selectedRecord.medicationFamilyId = this.selectedMedicationFamily.id;
			}

			this.selectedRecord.storageInstructions = String(this.valStorageInstructions).toUpperCase();
			this.selectedRecord.ingredients = this.valIngredients;
			if (this.selectedManuBy) {
				this.selectedRecord.manufacturedById = this.selectedManuBy.id;
			}
			if (this.selectedManuFor) {
				this.selectedRecord.manufacturedForId = this.selectedManuFor.id;
			}

			this.medicationService.updateMedication(this.selectedRecord).subscribe(
				(data2) => {
					this.isEditing = false;
					this.strErr = '';
					this.txService.updateTransactionHistory(this.historyRecord, this.selectedRecord, 'Medications', this.selectedRecord.id);
					this.updateSelectedRow()
				},
				(error) => {
				}
			);
		}
	}
	public updateSelectedRow(): void {
		if (this.isAdd === true) {
			// add the new record to the top.

			this.medicationsList.unshift(this.selectedRecord);
			this.dataSource.data = this.medicationsList;
			this.Idx = 0;
			this.displayDetail(this.selectedRecord);
		}
		else {
			const i: number = this.medicationsList.findIndex(r => r.id === this.selectedRecord.id);
			this.medicationsList[i] = this.selectedRecord;
			this.dataSource.data = this.medicationsList;
		}
		this.dataSource.sort = this.sort;
	}
	public onRowClicked(SR: Medication) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = SR;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public cancelSubmitRecord() {
		this.isEditing = false;
		if (this.isAdd) {
			this.clear();
		}
		else {
			this.displayDetail(this.selectedRecord);
		}
		this.strErr = '';
	}
	public removeRecord() {
		const message = 'Remove Medication: ' + this.selectedRecord.description + ' - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '500px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {

				this.medicationService.deleteMedication(this.selectedRecord.id).subscribe(
					(data2) => {
						this.isEditing = false;
						this.dataSource.data.slice(this.Idx);
						this.selectedRecord.activeStatus = 'Deleted';
						this.onChangeStatusFilterValue();
					},
					(error) => {
					}
				);
			}
		});
	}
	public chkDuplicateNDCNumber(paramNdcNumber) {

		this.medicationService.getMedicationByNDC(paramNdcNumber).subscribe(
			(result) => {
				if (result !== null && (!this.selectedRecord || result.id !== this.selectedRecord.id)) {
					this.strErr = 'Error: This NDC number already exists';
					DwUtils.setFocus('omNDCNumber');
				}
				else {
					this.strErr = '';
				}
			},
			(error) => {
				// nothing.
			});
	}
	public getMedicationFamily(paramId: number) {
		for (const rec of this.medicationFamilyList) {
			if (rec.id === paramId) {
				this.selectedMedicationFamily = rec;
				return this.selectedMedicationFamily;
			}
		}
		return undefined;
	}
	public showMedFamilySelection(): void {
		let filterVal = '';
		this.displayMedFamilyDlg = true;
		if (this.valDesc?.length > 4) {
			filterVal = this.valDesc.substr(0, 4);
		}
		this.medFamilyLookup.setTableData(filterVal);
	}
	public setMedicationFamilyRecord(rec: any): void {
		this.selectedMedicationFamily = rec;
		this.valMedicationFamily = rec.description;
		this.valDesc = rec.description;
		this.displayMedFamilyDlg = false;
	}
	public manuBySelected(id: number) {
		this.selectedManuBy = this.manufactureByList.find(item => item.id === id);
	}
	public manuForSelected(id: number) {
		this.selectedManuFor = this.manufactureForList.find(item => item.id === id);
	}

}
